import React from 'react';
export function HighSpeedMachiningSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10" data-id="element-2228">
      <h2 className="text-2xl font-bold text-[#1967a5] mb-6" data-id="element-2229">
        High Speed Machining
      </h2>
      <ul className="space-y-3 list-disc list-inside" data-id="element-2230">
        <li data-id="element-2231">
          <a href="/WhatIsHighSpeedMachining.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2232">
            What is High Speed Machining?
          </a>
        </li>
        <li data-id="element-2233">
          <a href="/MillingHSMvsHEM.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2234">
            What's the Difference Between High-Speed Machining and
            High-Efficiency Machining? (HEM vs. HSM)
          </a>
        </li>
        <li data-id="element-2235">
          <a href="/SecretstoHardMilling.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2236">
            Secrets to Hard Milling Success
          </a>
        </li>
        <li data-id="element-2237">
          <a href="/5axismachiningbenefits.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2238">
            Benefits of 5-Axis Machining
          </a>
        </li>
        <li data-id="element-2239">
          <a href="/MachiningCenterROI.html" className="text-orange hover:underline font-bold text-lg" data-id="element-2240">
            Calculating Machining Center ROI
          </a>
        </li>
      </ul>
    </div>;
}